import React, { useState, useRef } from "react";
import { useOpenModal } from "#utils/openModal";
import { Button, Space, Progress, Result, Upload, Message } from '@bedrock/components'
import { Download, FileExcelFilled, InfoCircle } from '@bedrock/icons-react'
import { dataImportData, dataMemoryImportData, outsourceDataImportData, outsourceDataMemoryImportData } from "#services/api";
import { UploadRequestOption } from "@bedrock/components/lib/Upload/Uploader/types";
import { useMemoizedFn } from 'ahooks'
import { downloadFile } from "#utils/download";
import "./index.less";
import {$sType} from "#utils";

enum UploadFileStatus {
    START = "start",
    SUCCESS = "success",
    LODING = 'loading',
    FAILED = 'failed'
}

export enum ImportFileType {
    supplier_batch_change_channel_supplier_type = 'supplier_batch_change_channel_supplier_type', // 供应商批量变更渠道供应商类型
    demand_kpi = 'demand_kpi', // 考核指标
    demand_category_property_template = 'demand_category_property_template', // 需求类型合作内容属性关联
    demand_cooperate_property = 'demand_cooperate_property', // 合作内容属性
    demand_quote_temp_content = 'demand_quote_temp_content', // 报价模板
    boost_effect = 'boost_effect', // 加热助推模板
    demand_standard_catalog_template = 'demand_standard_catalog_template', // 标品配置
}

type ReturnPrams = {
    openImportFileModal: (props: importFileModalProps) => void;
    closeImportFileModal: () => void;
}

type importFileModalProps = {
    importTitle?: string;
    importType?: ImportFileType | string;
    importIsMemory?: boolean; // 导入入库
    uploadFinishedCallback?: (data: any) => void; // 导入完成回调
    maxSize?: number;
    fileType?: string;
    isAttachments?: boolean;
    limit?: number;
    isShowUpdateTip?: boolean
    maskClosable?: boolean,
    scene?: string; // 场景，服务端导入参数
    // 自定义下载模板按钮
    customDownloadRender?: () => React.ReactNode;
    showSuccessToast?: boolean,
}

type defaultStateType = {
    percent: number;
    importFileStatus: UploadFileStatus;
    importData: any;
    currentFile: any;
    okButton: boolean;
    disabled: boolean;
}

const defaultState: defaultStateType = {
    percent: 0,
    importFileStatus: UploadFileStatus.START,
    currentFile: null,
    importData: {},
    okButton: false,
    disabled: false,
}


export const useImportFileModal = (props: importFileModalProps): ReturnPrams => {
    const [internalState, setInternalStat] = useState<defaultStateType>(defaultState)
    const [modalProps, setModalProps] = useState<importFileModalProps>(props)
    const {
        importTitle = '导入',
        importType, limit,
        importIsMemory = true,
        isShowUpdateTip = false,
        maskClosable = false,
        uploadFinishedCallback,
        maxSize = 50, fileType = '.xlsx',
        scene,
        customDownloadRender,
        showSuccessToast = true,
    } = modalProps;
    const { disabled, percent, importFileStatus, okButton, currentFile, importData } = internalState
    const defaultImportFile = () => {
        return (
            <Result
                className="import-file-default"
                icon={<FileExcelFilled />}
                title="点击或将模板拖拽到这里导入"
                content="仅支持xlsx格式"
            />
        )
    }
    const importFileSuccessfully = () => {
        return (
            <>
                <Result
                    className="import-file-success"
                    title={`${currentFile?.name}`}
                    icon={<FileExcelFilled />}
                    content={
                        <div>
                            <Progress
                                className="import-file-progress"
                                size="small"
                                state="success"
                                percent={percent}
                            />
                            <div className="file-tip">{percent === 100 ? `导入成功，已完成${percent}% ` : `正在导入数据，已完成${percent}% `}</div>
                        </div>
                    }
                />
            </>
        )
    }
    const importFileFailed = () => {
        const result = importData?.data
        return (
            <Result
                className="import-file-failed"
                title="导入失败"
                content={
                    <div className="import-result-content">
                        {
                            result?.fail_detail_download_url ?
                                '数据格式错误，请修复后重新导入，导入失败原因已记录在文件中' :
                                importData?.message
                        }
                        {/* {result?.fail_count > 0 &&
                            result?.fail_detail_download_url &&
                            <div>导入成功<span className="success-count">{result?.success_count}</span>条，导入失败<span className="fail-count">{result?.fail_count}</span>条，导入失败原因已记录在文件中</div>} */}
                        {/* {!result?.fail_detail_download_url && <div>{importData?.message || '模板错误，请下载模板后重新导入'}</div>} */}
                    </div>
                }
                type="error"
                actions={result?.fail_detail_download_url && <Button type="link" onClick={handleDownloadFile}>下载文件，查看失败原因</Button>}
            />
        )
    }
    const handleDownloadFile = () => {
        downloadFile(importData.data?.fail_detail_download_url)
    }
    const handleBlod = (url) => {
        // const link = document.createElement('a')
        // link.href = url
        // document.body.appendChild(link)
        // link.click()
        // document.body.removeChild(link)
        window.open(url)
    }

    const handleDownloadTemplate = async () => {
        const url = $sType === 'outer' ?
            `/api/outsource/v2/java_proxy/common/data/${importType}/import-template` :
            `/api/v2/java_proxy/common/data/${importType}/import-template`
        handleBlod(url)
    }
    const getUploadData = (file, uploadProgerssProps) => {

        if ($sType === 'outer') {
            // 王永泰逻辑写反了，垃圾
            if (importIsMemory) {
                return outsourceDataImportData({ type: importType }, file, uploadProgerssProps)
            } else {
                return outsourceDataMemoryImportData({ type: importType }, file, uploadProgerssProps)
            }
        } else {
            if (importIsMemory) {
                return dataImportData({ type: importType }, file, uploadProgerssProps)
            } else {
                return dataMemoryImportData({ type: importType }, file, uploadProgerssProps)
            }
        }

    }
    const afterUploadResult = useMemoizedFn((data) => {
        uploadFinishedCallback?.(data)
    })

    const uploadCancelRef = useRef((message: string) => { })
    const handleCustomRequest = useMemoizedFn((params: UploadRequestOption) => {
        const {
            file,
        } = params;
        const formData = new FormData()
        const uploadProgerssProps = {
            cancelRef: uploadCancelRef,
            onUploadProgress: (progressEvent) => {
                let percent = Math.round((progressEvent.loaded / progressEvent.total) * 100)
                percent = percent >= 99 ? 99 : percent
                setInternalStat({ ...internalState, percent, disabled: true, importFileStatus: UploadFileStatus.LODING, currentFile: file })
            }
        }
        formData.append("file", file)
        scene && formData.append("scene", scene)
        const isLt200M = (file as any)?.size / 1024 / 1024 <= maxSize;
        const isXlsx = (file as any)?.name.endsWith(fileType);
        if (!isXlsx) {
            Message.error(`仅支持${fileType}格式`);
            return
        }
        if (!isLt200M) {
            Message.error(`文件不能大于 ${maxSize}MB！`);
            return
        }
        setInternalStat({ ...internalState, currentFile: file })
        getUploadData(formData, { ...uploadProgerssProps }).then(importData => {
            let status = UploadFileStatus.LODING;
            if (importData.data.fail_count > 0) {
                status = UploadFileStatus.FAILED;
            } else {
                showSuccessToast && Message.success('导入成功')
            }
            setInternalStat({ ...internalState, okButton: true, percent: 100, importFileStatus: status, importData, currentFile: file, disabled: true })
            afterUploadResult(importData)

        }).catch(err => {
            setInternalStat({ ...internalState, disabled: true, okButton: true, importFileStatus: UploadFileStatus.FAILED, importData: err, currentFile: file })
            afterUploadResult(err)
        })
    })

    const { open, destroy } = useOpenModal({
        title: importTitle,
        width: 640,
        className: 'import-file-modal',
        okButton,
        okText: '重新上传',
        maskClosable,
        onOk: () => {
            setInternalStat({ ...internalState, disabled: false, percent: 100, importFileStatus: UploadFileStatus.START, okButton: false })
            return Promise.reject()
        },
        children: (
            <Space className="upload-container-children" size={12} direction='vertical'>
                {isShowUpdateTip && <div className="info">
                    <InfoCircle style={{ marginRight: '8px' }} />
                    <span className="info-span">导入支持新增和更新，更新将覆盖需求类型关联的原报价内容。</span>
                </div>}
                <div className="download">
                    {customDownloadRender ? customDownloadRender() : <>
                        <Button onClick={handleDownloadTemplate} icon={<Download />} type='link'>下载模板</Button>
                        <span className="download-span">(上传前请先下载Excel模板并按照模板格式编辑文件)</span>
                    </>}
                </div>
                <Upload
                    className="import-upload-modal"
                    type="draggable"
                    tip="仅支持xlsx格式"
                    size='default'
                    accept={fileType}
                    disabled={disabled}
                    limit={limit}
                    customRequest={handleCustomRequest}
                    trigger={
                        <div className="import-trigger-container">
                            {importFileStatus === UploadFileStatus.START && defaultImportFile()}
                            {importFileStatus === UploadFileStatus.LODING && importFileSuccessfully()}
                            {importFileStatus === UploadFileStatus.FAILED && importFileFailed()}
                        </div>
                    }
                />
            </Space>
        ),
        afterClose: () => {
            if (typeof uploadCancelRef?.current === 'function') {
                uploadCancelRef?.current?.('关闭窗口，取消上传')
            }
        }
    })

    const openImportFileModal = useMemoizedFn((openProps: importFileModalProps) => {
        setModalProps({ ...modalProps, ...openProps })
        setInternalStat({ ...defaultState })
        open()
    })
    return {
        openImportFileModal,
        closeImportFileModal: destroy,
    }
};